import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button } from '@chakra-ui/react';
import Lottie from 'react-lottie-player';
import animatedLogoLottie from '@/assets/json/animated-logo-lottie.json';
export const FormButton = (props) => {
    const newProps = Object.assign({}, props);
    newProps.loading = undefined;
    return (_jsxs(Button, Object.assign({ borderRadius: '14px', fontSize: '16px', minH: '50px', w: '100%' }, newProps, { children: [_jsx(Box, Object.assign({ display: props.loading ? 'block' : 'none', pos: 'absolute', style: { filter: 'brightness(1000%)' }, zIndex: '1' }, { children: _jsx(Lottie, { animationData: animatedLogoLottie, loop: true, play: true, speed: 3, style: { height: 40, width: 40 } }) })), _jsx(Box, Object.assign({ pos: 'relative', zIndex: props.loading ? -1 : 0 }, { children: props.children }))] })));
};
